/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S32_Item_2Inputs */

const es_privacy_policy_data_collected_s32_item_2 = /** @type {(inputs: Privacy_Policy_Data_Collected_S32_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paginas visitadas, tiempo de visita y marca de tiempo`)
};

const en_privacy_policy_data_collected_s32_item_2 = /** @type {(inputs: Privacy_Policy_Data_Collected_S32_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages visited, visit time and timestamp`)
};

/**
* | output |
* | --- |
* | "Pages visited, visit time and timestamp" |
*
* @param {Privacy_Policy_Data_Collected_S32_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s32_item_2 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S32_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S32_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s32_item_2(inputs)
	return en_privacy_policy_data_collected_s32_item_2(inputs)
});
export { privacy_policy_data_collected_s32_item_2 as "privacy_policy.data_collected.s32_item_2" }